import {Popover} from '@headlessui/react'
import classNames from 'classnames'
import {Link} from 'gatsby'
import * as React from 'react'

import {DEFAULT_LOCALE, LOCALES} from '@/common/config'
import {getUnlocalizedFullSlug, urljoinWithTrailing} from '@/common/utils'

export const LanguageSwitcherFooter = ({story = {}, className}) => {
  const activeLocale = story.lang === 'default' ? DEFAULT_LOCALE : story.lang
  const unlocalizedFullSlug = getUnlocalizedFullSlug(story.full_slug)

  if (LOCALES.length) {
    return (
      <Popover className={classNames('fit-content relative lg:absolute lg:right-12', className)}>
        {({open}) => (
          <>
            <Popover.Button className='flex items-center gap-2 rounded-2xl bg-white/20 px-4 py-2 pl-4 text-white'>
              <span className='uppercase'>{activeLocale}</span>
              <span aria-hidden>
                {open ? (
                  <svg
                    width='16'
                    height='9'
                    viewBox='0 0 16 9'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                    className='rotate-180'
                  >
                    <path
                      d='M14.6666 0.666672L7.99992 7.33334L1.33325 0.666672'
                      stroke='white'
                      stroke-linecap='round'
                    />
                  </svg>
                ) : (
                  <svg
                    width='16'
                    height='9'
                    viewBox='0 0 16 9'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M14.6666 0.666672L7.99992 7.33334L1.33325 0.666672'
                      stroke='white'
                      stroke-linecap='round'
                    />
                  </svg>
                )}
              </span>
            </Popover.Button>

            <Popover.Panel className='absolute left-0 top-[41px] flex w-full flex-col rounded-2xl bg-white/20 px-4 py-2 pl-4 text-center uppercase text-white backdrop-blur-sm'>
              {LOCALES.concat(DEFAULT_LOCALE)
                .sort()
                .map((locale) => {
                  const localePath = locale === DEFAULT_LOCALE ? '' : locale
                  const href = urljoinWithTrailing(localePath, unlocalizedFullSlug)

                  return (
                    <Link key={locale} to={`/${href}`}>
                      {locale}
                    </Link>
                  )
                })}
            </Popover.Panel>
          </>
        )}
      </Popover>
    )
  }

  return null
}
